module.exports = __webpack_public_path__ + "static/media/kalevankatu.6a2be5a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kalevankatu.svg
// module id = 120
// module chunks = 0